import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import AutomaticDiscountForm from '@/components/v2/AutomaticDiscountForm.vue';
import AutomaticDiscountFragment from '@/plugins/graphql/fragments/v2/automatic-discount.gql';
import AutomaticDiscountDetails from '@/plugins/graphql/queries/v2/automatic-discount.gql';
import { AutomaticDiscountInputModel } from '@/helpers/entities/models/AutomaticDiscountInputModel';
import AutomaticDiscountMixin from '@/helpers/vue_mixins/v2/ecommerce/AutomaticDiscountMixin';
import AutomaticDiscountUpdate from '@/plugins/graphql/mutations/v2/automatic-discount-update.gql';
let AutomaticDiscountEdit = class AutomaticDiscountEdit extends mixins(AlertMixin, RouterParamsAppMixin, AutomaticDiscountMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.automaticDiscount = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.automaticDiscount.loading;
    }
    get formData() {
        const { automaticDiscount } = this;
        const data = {
            name: null,
            value: null,
            startAt: null,
            endAt: null,
            endAtTime: null,
            startAtTime: null,
            usageLimit: null,
            active: true,
            discountType: null,
            oneTime: false,
        };
        if (automaticDiscount) {
            const { uuid, active, name, usageLimit, value, discountType, oneTime } = automaticDiscount;
            return {
                uuid,
                name,
                endAt: automaticDiscount.endAt === null ? null : automaticDiscount.formattedEndAt,
                startAt: automaticDiscount.startAt === null ? null : automaticDiscount.formattedStartAt,
                usageLimit,
                value,
                active,
                endAtTime: automaticDiscount.endAt === null ? null : automaticDiscount.formattedEndAtTime,
                startAtTime: automaticDiscount.startAt === null ? null : automaticDiscount.formattedStartAtTime,
                discountType,
                oneTime,
            };
        }
        return data;
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.update(form)
            .then(() => {
            const msg = successfulUpdate('Automatic Discount');
            this.voucherAction('SUBMIT EDIT');
            this.successNotification(msg);
            this.goToAutomaticDiscountsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const { name, value, active } = form;
        const automaticDiscountUUID = form.uuid;
        try {
            await this.$apollo.mutate({
                mutation: AutomaticDiscountUpdate,
                variables: {
                    input: {
                        name,
                        value,
                        usageLimit: Number(form.usageLimit),
                        startAt: new Date(`${form.startAt}T${form.startAtTime}`),
                        endAt: new Date(`${form.endAt}T${form.endAtTime}`),
                        active,
                        automaticDiscountUuid: this.uuid,
                        discountType: form.discountType,
                        oneTime: form.oneTime,
                    },
                },
                update(cache, { data }) {
                    const { automaticDiscount } = data.automaticDiscountUpdate;
                    automaticDiscount.uuid = automaticDiscountUUID;
                    cache.writeFragment({
                        id: automaticDiscountUUID,
                        fragment: AutomaticDiscountFragment,
                        data: automaticDiscount,
                        fragmentName: 'AutomaticDiscount',
                    });
                    cache.writeQuery({
                        query: AutomaticDiscountDetails,
                        variables: {
                            automaticDiscountUUID,
                        },
                        data: {
                            fetchSpecificAutomaticDiscount: automaticDiscount,
                        },
                    });
                },
            });
        }
        catch (err) {
            if (err instanceof Error) {
                console.error('Apollo mutation error:', err.message);
                throw new Error(err.message || 'An error occurred while updating the discount.');
            }
            else {
                console.error('Unknown error:', err);
                throw new Error('An unknown error occurred while updating the discount.');
            }
        }
    }
};
__decorate([
    Prop({ type: String, required: true })
], AutomaticDiscountEdit.prototype, "uuid", void 0);
AutomaticDiscountEdit = __decorate([
    Component({
        components: {
            PageTitle,
            AutomaticDiscountForm,
        },
        apollo: {
            automaticDiscount: {
                query: AutomaticDiscountDetails,
                variables() {
                    const automaticDiscountUuid = this.uuid;
                    return {
                        automaticDiscountUuid,
                    };
                },
                update(data) {
                    return new AutomaticDiscountInputModel(data.fetchSpecificAutomaticDiscount);
                },
            },
        },
    })
], AutomaticDiscountEdit);
export default AutomaticDiscountEdit;
